export const acceptableMediaTypes = {
  image: {
    'image/png': ['.png'],
    'image/jpg': ['.jpg'],
    'image/jpeg': ['.jpeg'],
  },
  video: {
    'video/mp4': ['.mp4'],
  },
};

export const VIDEO_SIZE_MB = 10;
export const IMAGE_SIZE_MB = 5;
